import React, { useEffect, useState } from 'react';
import { Container, Nav, Navbar, NavDropdown, Row, Col, Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Dropdown } from 'primereact/dropdown';
import { faHexagonCheck } from '@fortawesome/pro-solid-svg-icons';

const DropdownPicker = (props) => { 
    const [optionLabel, setOptionLabel] = useState('name');

    useEffect(() => {
        if (props.optionLabel) {
            setOptionLabel(props.optionLabel);
        }
    }, [props.optionLabel]);

    const itemTemplate = (option) => {
        return (
            <div key={option[optionLabel]} className="item">
                {props.selectedListItem && option[optionLabel] === props.selectedListItem[[optionLabel]] ? (
                    <Row>
                        <Col className='p-t-0 p-b-0'>
                            {option[optionLabel]}
                        </Col>
                        <Col className='text-align-right p-t-0 p-b-0'>
                            <FontAwesomeIcon className='selected-item-icon' icon={faHexagonCheck} />
                        </Col>
                    </Row>
                ) : (
                    <div className='option-label'>{option[optionLabel]}</div>
                )}
            </div>
        );
    };

    return (
        <div className="DropdownPicker transition">
            <Dropdown
                data-testid={props.testId}
                value={props.selectedListItem}
                onChange={(e) => props.onListItemChange(e.value, props.selectedListItem)}
                options={props.listData}
                optionLabel={optionLabel}
                placeholder={props.placeholder}
                className="dropdown w-full transition"
                itemTemplate={props.icon ? itemTemplate : null}
                disabled={props.disabled}
                width={props.width ? props.width : '100%'}
                showClear={props.showClear ? props.showClear : false}
            />
        </div>
    );
};

export default DropdownPicker;
